import { nanoid } from "nanoid";
import {
  CalendarOutlined,
  FieldTimeOutlined,
  BoldOutlined,
  LineOutlined,
  DownSquareOutlined,
  CheckCircleOutlined,
  TableOutlined,
  BorderlessTableOutlined,
  HolderOutlined,
  NumberOutlined,
  FormOutlined,
  ToTopOutlined,
  PlaySquareOutlined,
  FunctionOutlined,
  EditOutlined,
  SlidersOutlined,
  PictureOutlined,
  PlusOutlined,
  CheckSquareOutlined,
  BarChartOutlined,
  FontSizeOutlined,
  GroupOutlined,
} from "@ant-design/icons";

export const defaultItems = [
  {
    key: "Title",
    name: "Title",
    searchtext: "text,caption,header",
    categoryType: ["Popular", "Texts"],
    iconLink: <FontSizeOutlined style={{ verticalAlign: "middle" }} />,
    static: true,
    field_name: "title_",
    content: "New Title",
    bold: true,
  },
  {
    key: "ResultCell",
    name: "Result (formula)",
    searchtext: "cell",
    categoryType: ["Popular", "Display"],
    static: true,
    iconLink: <FunctionOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "result_cell_",
    showCaptionInside: false,
    content: "<strong>Result</strong>",
  },
  {
    key: "BlockPlaceholder",
    name: "BlockPlaceholder",
    searchtext: "",
    categoryType: ["Blocks"],
    content: "Block Placeholder",
    disabled: true,
  },
  {
    key: "Range",
    name: "Number Slider",
    searchtext: "",
    categoryType: ["Popular", "Action"],
    canHaveAnswer: true,
    iconLink: <SlidersOutlined style={{ verticalAlign: "middle" }} />,
    label: "<strong>Slider</strong>",
    field_name: "range_",
    step: 1,
    editor_style: "",
    min_value: 1,
    max_value: 50,
    min_label: "",
    max_label: "",
    cell: "",
  },
  {
    key: "NumberInput",
    canHaveAnswer: true,
    name: "Number Input",
    searchtext: "",
    categoryType: ["Popular", "Action"],
    label: "<strong>Number</strong>",
    iconLink: <PlusOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "number_input_",
    step: 1,
    editor_style: "",
    min_value: null,
    max_value: null,
    min_label: "",
    max_label: "",
    show_buttons: false,
    cell: "",
  },
  {
    key: "TextInput",
    canHaveAnswer: true,
    name: "Text Input",
    searchtext: "",
    categoryType: ["Popular", "Texts"],
    label: "<strong>Text</strong>",
    iconLink: <EditOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "text_input_",
    cell: "",
  },
  {
    key: "Dropdown",
    canHaveAnswer: true,
    name: "Dropdown",
    searchtext: "multiple choice,choose,select",
    categoryType: ["Popular", "Action"],
    iconLink: <DownSquareOutlined style={{ verticalAlign: "middle" }} />,
    label: "<strong>Dropdown</strong>",
    videoId: "haujwh7h6x",
    field_name: "dropdown_",
    cell: "",
    options: [],
  },
  {
    key: "TwoColumnRow",
    canHaveAnswer: false,
    name: "Multi Column Row",
    searchtext: "responsive,horizontal,card,group",
    categoryType: ["Popular", "Layout"],
    label: "",
    videoId: "2l4232sbkb",
    iconLink: <NumberOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "two_col_row_",
    columnCount: 2
  },
  {
    key: "ResultChart",
    name: "Chart (from workbook)",
    searchtext: "pie,bar,line,area,scatter,bubble",
    categoryType: ["Popular", "Display"],
    static: true,
    iconLink: <BarChartOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "result_chart_",
    content: "<strong>Chart</strong>",
    element_id: "",
  },
  {
    key: "ActionButton",
    name: "ActionButton",
    searchtext: "print,click,jump,send",
    categoryType: ["Popular", "Action"],
    iconLink: <PlaySquareOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "button_",
    content: "Action Button",
    videoId: "2g7au7ddkl",
    endpoint_url: "",
    open_url: "",
  },
  {
    key: "SpreadTable",
    name: "Grid (cell area)",
    searchtext: "grid,range,sheet,spread,cells,list,conditional",
    categoryType: ["Popular", "Display"],
    static: true,
    iconLink: <BorderlessTableOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "spread_table_",
    content: "<strong>Editable grid</strong>",
    element_id: "",
  },
  // {
  //   key: "TableView",
  //   name: "Table Vew",
  //   searchtext: "table,view,grid,kanban,list,calendar,map",
  //   categoryType: ["Display"],
  //   static: true,
  //   iconLink: <BorderlessTableOutlined style={{ verticalAlign: "middle" }} />,
  //   field_name: "table_view_",
  //   content: "<strong>Table View</strong>",
  //   element_id: "",
  // },
  {
    key: "ResultTable",
    name: "Table (cell area)",
    searchtext: "grid,range,list,conditional",
    categoryType: ["Popular", "Display"],
    static: true,
    iconLink: <TableOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "result_table_",
    content: "<strong>Resulting table</strong>",
    element_id: "",
  },
  {
    key: "Header",
    name: "Rich Text",
    searchtext: "text,caption,header,description",
    categoryType: ["Popular", "Texts"],
    iconLink: <BoldOutlined style={{ verticalAlign: "middle" }} />,
    static: true,
    field_name: "header_",
    content:
      '<h4><strong>I&#39;m a rich text component</strong></h4><p><span style="font-size: 14px;">Rich texts can include formatting commands for page layout such as fonts, <strong>bold</strong>, <u>underline</u>, <em>italic</em>, etc. It may also refer to a multimedia document that can include images, tables, audio and video.</span></p>',
  },
  {
    key: "Checkbox",
    canHaveAnswer: true,
    name: "Checkbox",
    searchtext: "true,false,hide",
    categoryType: ["Popular", "Action"],
    label: "<strong>Checkbox</strong>",
    videoId: "lni91v7kfc",
    iconLink: <CheckSquareOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "checkbox_",
    cell: "",
  },
  {
    key: "RadioButtons",
    canHaveAnswer: true,
    name: "Multiple Choice",
    searchtext: "radio,dropdown,choose,select",
    categoryType: ["Action"],
    iconLink: <CheckCircleOutlined style={{ verticalAlign: "middle" }} />,
    label: "<strong>Multiple Choice</strong>",
    field_name: "radiobuttons_",
    cell: "",
    options: [],
  },
  {
    key: "TextArea",
    canHaveAnswer: true,
    name: "Multi-line Input",
    searchtext: "",
    categoryType: ["Texts"],
    label: "<strong>Multi-line</strong>",
    iconLink: <FormOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "text_area_",
    cell: "",
  },
  {
    key: "DatePicker",
    canHaveAnswer: true,
    canDefaultToday: true,
    canReadOnly: true,
    dateFormat: "MM/dd/yyyy",
    timeFormat: "hh:mm aa",
    dateSelector: "date",
    showTimeSelect: false,
    showTimeSelectOnly: false,
    name: "Date",
    searchtext: "",
    categoryType: ["Popular", "Action"],
    iconLink: <CalendarOutlined style={{ verticalAlign: "middle" }} />,
    label: "<strong>Date</strong>",
    field_name: "date_picker_",
    cell: "",
  },
  {
    key: "TimePicker",
    canHaveAnswer: true,
    canDefaultToday: true,
    canReadOnly: true,
    timeFormat: "hh:mm",
    showTimeSelect: false,
    showTimeSelectOnly: false,
    name: "Time",
    searchtext: "",
    categoryType: ["Action"],
    iconLink: <FieldTimeOutlined style={{ verticalAlign: "middle" }} />,
    label: "<strong>Time</strong>",
    field_name: "time_picker_",
    cell: "",
  },
  {
    key: "LineBreak",
    name: "Line Break",
    searchtext: "",
    categoryType: ["Layout"],
    static: true,
    field_name: "line_break_",
    iconLink: <LineOutlined style={{ verticalAlign: "middle" }} />,
  },
  {
    key: "Spacer",
    name: "Spacer",
    searchtext: "",
    categoryType: ["Layout"],
    static: true,
    height_value: 50,
    field_name: "spacer_",
    iconLink: (
      <ToTopOutlined rotate={180} style={{ verticalAlign: "middle" }} />
    ),
  },
  {
    key: "Image",
    name: "Image",
    searchtext: "picture,",
    categoryType: ["Layout"],
    label: "",
    iconLink: <PictureOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "image_",
    src: "",
  },
  {
    key: "Section",
    canHaveAnswer: false,
    name: "Page",
    searchtext: "page,",
    categoryType: ["Layout"],
    videoId: "9fr13xm4te",
    hidden: true,
    label: "",
    iconLink: (
      <HolderOutlined rotate={90} style={{ verticalAlign: "middle" }} />
    ),
    field_name: "result_section_",
  },
  {
    key: "Background",
    canHaveAnswer: false,
    name: "Background",
    searchtext: "background,",
    categoryType: ["Layout"],
    hidden: true,
    iconLink: <GroupOutlined rotate={90} style={{ verticalAlign: "middle" }} />,
    field_name: "background_",
  },
  {
    key: "SingleColumnRow",
    canHaveAnswer: false,
    name: "1-Column Row",
    searchtext: "responsive,horizontal,card,group",
    categoryType: ["Layout"],
    label: "",
    iconLink: <NumberOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "single_col_row_",
    columnCount: 1
  },
  {
    key: "ThreeColumnRow",
    canHaveAnswer: false,
    name: "3-Column Row",
    searchtext: "responsive,horizontal,card,group",
    categoryType: ["Layout"],
    label: "",
    videoId: "2l4232sbkb",
    iconLink: <NumberOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "three_col_row_",
    columnCount: 3
  },
  {
    key: "FourColumnRow",
    canHaveAnswer: false,
    name: "4-Column Row",
    searchtext: "responsive,horizontal,card,group",
    categoryType: ["Layout"],
    label: "",
    videoId: "2l4232sbkb",
    iconLink: <NumberOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "four_col_row_",
    columnCount: 4
  },
  {
    key: "FiveColumnRow",
    canHaveAnswer: false,
    name: "5-Column Row",
    searchtext: "responsive,horizontal,card,group",
    categoryType: ["Layout"],
    label: "",
    videoId: "2l4232sbkb",
    iconLink: <NumberOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "five_col_row_",
    columnCount: 5
  },
  {
    key: "SixColumnRow",
    canHaveAnswer: false,
    name: "6-Column Row",
    searchtext: "responsive,horizontal,card,group",
    categoryType: ["Layout"],
    label: "",
    videoId: "2l4232sbkb",
    iconLink: <NumberOutlined style={{ verticalAlign: "middle" }} />,
    field_name: "six_col_row_",
    columnCount: 6
  },
  // {
  //   key: 'FileUpload',
  //   canHaveAnswer: false,
  //   name: 'File Upload',
  //   hidden: false,
  //   label: '<strong>File Upload</strong>',
  //   iconLink: <UploadOutlined style={{ verticalAlign: 'middle' }} />,
  //   field_name: 'file_upload_',
  // },
  // {
  //   key: 'Variable',
  //   canHaveAnswer: false,
  //   name: 'Variable',
  //   hidden: true,
  //   label: '',
  //   iconLink: <CalculatorOutlined style={{ verticalAlign: 'middle' }} />,
  //   field_name: 'result_variable_',
  // }
];

export const defaultItemOptions = (element) => {
  switch (element) {
    case "Dropdown":
      return [
        {
          value: "option_1",
          text: "Option 1",
          key: `dropdown_option_${nanoid()}`,
        },
        {
          value: "option_2",
          text: "Option 2",
          key: `dropdown_option_${nanoid()}`,
        },
        {
          value: "option_3",
          text: "Option 3",
          key: `dropdown_option_${nanoid()}`,
        },
      ];
    case "RadioButtons":
      return [
        {
          value: "option_1",
          text: "Option 1",
          key: `radiobuttons_option_${nanoid()}`,
        },
        {
          value: "option_2",
          text: "Option 2",
          key: `radiobuttons_option_${nanoid()}`,
        },
        {
          value: "option_3",
          text: "Option 3",
          key: `radiobuttons_option_${nanoid()}`,
        },
      ];
    default:
      return [];
  }
};
